export default "__VITE_ASSET__D92S3fF6__"